import * as actionTypes from '../../constants/actionTypes';

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ARCHIVED_SEGMENT_CURRENT_PAGE:
      return Object.assign({}, action.paginationInfo);
    default:
      return state;
  }
}
